// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"Logo_logoWrapper__1_1-y","logo":"Logo_logo__3IG6m","text":"Logo_text__2tII4","logo_phone":"Logo_logo_phone__3nMrj"};